import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { productOptions } from '../../constants/productOptions';
import { flexCenter, flexSpaceBetween, breakpoints } from '../../constants/styles';
import Text from './Text';

const Card = styled.div`
  display: flex;
  align-items: center;
  align-content: space-between;
  height: 100%;
`;

const Container = styled.div`
  ${flexSpaceBetween}
  flex-direction: column;
  width: 70%;
  height: 100%;
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-content: flex-start;
  width: 90%;
`;

const ListElement = styled.div`
  ${flexSpaceBetween}
  width: 100%;
`;

const StyledOptionsLink = styled.a`
  padding-bottom: 2px;
`;

const ButtonSection = styled.div`
  display: flex;
  justify-content: space-around;
  width: 90%;
`;

const StyledImage = styled.img`
  width: 30%;
`;

const ProductOptions = props => {
  const { productType } = props;
  return productOptions.get(productType).map(product => (
    <Card key={`financial-product-${product.imgSrc}`}>
      <StyledImage alt="imagen" src={product.imgSrc} />
      <Container>
        <Fragment>
          {product.listElements.map(element => (
            <List key={`financial-product-element-${element.label}`}>
              {
                <ListElement>
                  <Text>{element.label}</Text>
                  <Text>{element.value}</Text>
                </ListElement>
              }
            </List>
          ))}
        </Fragment>
        <ButtonSection>
          <StyledOptionsLink>
            <Text>Más Información</Text>
          </StyledOptionsLink>
          <StyledOptionsLink>
            <Text>{product.buttons.callToAction}</Text>
          </StyledOptionsLink>
        </ButtonSection>
      </Container>
    </Card>
  ));
};

ProductOptions.propTypes = {
  type: PropTypes.string,
};

ProductOptions.defaultProps = {
  type: '',
};

export default ProductOptions;
